import axios from "axios";
import { ENDPOINT_HOME, ENDPOINT_HOME_UPDATE } from "../../../constants";
import { ApiResponse } from "../../types";
import { handleApiError } from "../../../utils/error_handler";

// create a theme based from data and returns new theme id
export async function retrieveHomeData() : Promise<{}> {
    try {
        const res = await axios.get<ApiResponse<{}>>(ENDPOINT_HOME);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        console.log(res.data.Msg)
        return res.data.Msg as {};
    } catch (error) {
        throw handleApiError(error);
    }
}

export async function updateHomeData(data:any) : Promise<void> {
    try {
        const res = await axios.post<ApiResponse<void>>(ENDPOINT_HOME_UPDATE, data);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        console.log(res.data.Msg)
        return res.data.Msg as void;
    } catch (error) {
        throw handleApiError(error);
    }
}